import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


const __default__ = {
  name: 'ColorPanel'
}

import { NTabs, NTabPane, NColorPicker } from 'naive-ui'
import CommonPicker from '../commonPicker.vue'
import { hexaToRgba } from '@/utils/transformColor'
import { onMounted, ref } from 'vue'
import Color from 'color'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    color: null
  },
  emits: ['update:color'],
  setup(__props: any, { emit }) {

const props = __props as {
  color: string
}



const color = ref(props.color)


onMounted(() => {
  try {
    const value = Color(props.color)
    color.value = value.hexa()
  } catch (error) {
    color.value = ''
  }
})

const onUpdateColor = (val: string) => {
  color.value = val
  emit('update:color', hexaToRgba(val))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NTabs), {
    "justify-content": "space-evenly",
    type: "bar",
    class: "tab-color-picker",
    tabStyle: { height: 'px' }
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NTabPane), {
        class: "color-tab__content",
        name: "common",
        tab: "常用颜色"
      }, {
        default: _withCtx(() => [
          _createVNode(CommonPicker, {
            color: color.value,
            onComplete: onUpdateColor
          }, null, 8, ["color"])
        ]),
        _: 1
      }),
      _createVNode(_unref(NTabPane), {
        class: "color-tab__content",
        name: "more",
        tab: "其他颜色"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NColorPicker), {
            class: "picker",
            size: "large",
            modes: ['hex'],
            show: true,
            defaultValue: color.value,
            onComplete: onUpdateColor
          }, null, 8, ["defaultValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})